// This component displays a welcome message card to users when they first
// access the CEA Screening Tool. It provides an overview of the tool's
// purpose and a contact email for feedback or questions. The message can be
// dismissed by the user.

import * as React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import {Badge} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {useState, useRef, useEffect} from "react";
import LicenseAgreement from "./LicenseAgreement";
import Form from 'react-bootstrap/Form';

// WelcomeMessage is a React functional component that renders a dismissible
// welcome card with information about the CEA Screening Tool.
function WelcomeMessage(props) {
    // State to control the visibility of the welcome message card.
    const [visible, setVisible] = useState(true)
    const [scrolled, setScrolled] = useState(false);
    const [agreed, setAgreed] = useState(false);
    const licenseRef = useRef(null);

    const handleScroll = () => {
        if (licenseRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = licenseRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 5) { // 5px buffer
                setScrolled(true);
            }
        }
    };

    useEffect(() => {
        const currentLicenseRef = licenseRef.current;
        if (currentLicenseRef) {
            currentLicenseRef.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (currentLicenseRef) {
                currentLicenseRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);


    // Handler to close the welcome message card.
    const handleWelcomeMsgClose = () => {
        setVisible(false)
    };

    // Render the welcome message card if visible.
    return (
        <>
            {visible &&
                <Card
                    style={{
                        display: "block",
                        width: "38%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        // borderColor: "blue",
                        position: "relative",
                        height: "650px",
                        top: "75px",
                    }}>
                    <Card.Body>
                        <Accordion.Header>
                            <b>Welcome to Berkeley Lab's CEA SiteScout Tool</b>
                        </Accordion.Header>
                        <hr className={'mb-0'}/>
                        <div className={'d-flex align-content-center'}>
                            <p style={{fontSize: '14px'}}>
                                <br/>
                                {/* Brief description of the tool's purpose and features. */}
                                A powerful, data-driven platform designed to
                                support informed site selection for controlled
                                environment agriculture (CEA).<br/>
                                <br/>
                                Our tool integrates environmental, social, and
                                infrastructure data with a flexible, facility-specific model
                                of energy use, water consumption, and emissions
                                intensity, offering a comprehensive framework
                                for
                                evaluating site feasibility. <br/>
                                <br/>
                                We hope the tool provides valuable insights
                                to guide
                                your CEA planning.
                                Have questions or feedback?
                                We'd love to hear from you!
                                <br/>
                                Contact us at {' '}
                                <a href="mailto: ceascreeningtooldev@gmail.com">
                                    <strong>ceascreeningtooldev@gmail.com</strong>
                                </a>
                                <br/>
                            </p>

                        </div>
                        <div
                            ref={licenseRef}
                            style={{
                                height: '240px',
                                overflowY: 'scroll',
                                border: '1px solid #ccc',
                                padding: '10px',
                                marginTop: '10px'
                            }}
                        >
                            <LicenseAgreement />
                        </div>
                        <Form.Group controlId="formBasicCheckbox" className="mt-2 license-agreement-checkbox">
                            <Form.Check
                                type="checkbox"
                                label="I agree to the user license agreement"
                                checked={agreed}
                                disabled={!scrolled}
                                onChange={(e) => setAgreed(e.target.checked)}
                            />
                        </Form.Group>
                        <div>
                            {/* Show the "Explore the Tool" button if not loading, otherwise show the loading message. */}
                            {!props.loading ? (
                                <div style={{
                                    textAlign: "center",
                                    height: '20px',
                                    marginTop: '5px'
                                }}>
                                    <Button className={'btn-sm'}
                                            onClick={handleWelcomeMsgClose}
                                            disabled={!agreed}
                                    >
                                        Explore the Tool
                                    </Button>
                                </div>
                            ) : (
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "60px",
                                }}>
                                    <p>Map content loading...</p>
                                    {props.spinner}
                                </div>
                            )}
                        </div>
                    </Card.Body>
                </Card>
            }
        </>
    )
}
;

export default React.memo(WelcomeMessage);
